import React from "react";
//Libraries
import { Link } from "react-router-dom";

const Pagination = ({ currentPage = 1, totalPages = 4, onPageChange }) => {
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  const handleClick = (page) => (e) => {
    e.preventDefault();

    // First scroll to top
    window.scrollTo({ top: 0, behavior: "smooth" });

    // Then change the page after a small delay
    // This ensures the scroll happens correctly
    setTimeout(() => {
      if (onPageChange) {
        onPageChange(page);
      }
    }, 100);
  };

  return (
    <ul className='pagination pagination-style-01 font-sans font-medium items-center'>
      <li className='page-item'>
        <Link
          aria-label='Previous page'
          className='page-link'
          to='#'
          onClick={handleClick(Math.max(1, currentPage - 1))}
        >
          <i className='feather-arrow-left text-lg'></i>
        </Link>
      </li>

      {pages.map((page) => (
        <li
          key={page}
          className={`page-item ${currentPage === page ? "active" : ""}`}
        >
          <Link
            aria-label={`Page ${page}`}
            className='page-link'
            to='#'
            onClick={handleClick(page)}
          >
            {String(page).padStart(2, "0")}
          </Link>
        </li>
      ))}

      <li className='page-item'>
        <Link
          aria-label='Next page'
          className='page-link'
          to='#'
          onClick={handleClick(Math.min(totalPages, currentPage + 1))}
        >
          <i className='feather-arrow-right text-lg'></i>
        </Link>
      </li>
    </ul>
  );
};

export default Pagination;
